import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const addCourse = createAsyncThunk('addCourse', async (data) => {

    try {
        const res = await axios({

            method: 'POST',
            url: getConfig.API_URL + 'course',
            data: {
                "course_name": data?.values?.course_name,
                "description": data?.values?.description,
                "headoffice_course_id": data?.values?.headoffice_course_id || "",
                // "status": data?.values?.status,
                "subjects": data?.values?.subjects
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})
